import { render, staticRenderFns } from "./feedetail.vue?vue&type=template&id=2e83043a&scoped=true"
import script from "./feedetail.vue?vue&type=script&lang=ts"
export * from "./feedetail.vue?vue&type=script&lang=ts"
import style0 from "./feedetail.vue?vue&type=style&index=0&id=2e83043a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e83043a",
  null
  
)

export default component.exports